import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { NavItem } from '@/types/nav-item';
import { NavLink } from './nav-link';

export type NavLinksProps = {
  items: NavItem[];
  darkVariant?: boolean;
  iconOnly?: boolean;
};

// TODO: move to a helper / util
const defaultActiveMatcher = (to: string, pathname: string) =>
  pathname.startsWith(to);

export const NavLinks: FC<NavLinksProps> = ({
  items,
  darkVariant,
  iconOnly,
}) => {
  const { pathname } = useLocation();

  return (
    <nav>
      <ul>
        {items.map((item) => (
          <li className="mb-1 last:mb-0" key={item.title}>
            <Tooltip
              anchorSelect={`#${item.title}-${iconOnly}`}
              className="fixed z-10"
              place="right"
            >
              {item.tooltip}
            </Tooltip>
            <a id={`${item.title}-${iconOnly}`}>
              <NavLink
                {...item}
                active={(item.activeMatcher ?? defaultActiveMatcher)(
                  item.to,
                  pathname,
                )}
                darkVariant={darkVariant}
                iconOnly={iconOnly}
              />
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
